export const DoneLoadingIndicator = () => <div data-testid="doneLoadingSpinner" className="tw:h-0! tw:w-0!" />;
